import { useTranslation } from 'react-i18next';

import { DataPanelInlineItem } from '@/ui';
import { PhoneNumber } from '@/lib/phone/phoneNumber';
import { openPhoneNumberDialog } from '../../actions';

export type PhoneNumberListPanelProps = {
  incidentId: string;
  phoneNumbers: readonly string[];
  editable?: boolean;
};

export function PhoneNumberListPanel({ incidentId, phoneNumbers, editable = false }: PhoneNumberListPanelProps) {
  const { t } = useTranslation();

  if (phoneNumbers.length > 0) {
    return (
      <>
        {phoneNumbers.map((callerPhoneNumber) => {
          const parsed = PhoneNumber.tryInitialize(callerPhoneNumber);
          return (
            <DataPanelInlineItem
              key={callerPhoneNumber}
              title={t('Incident_InfoPanel_Phone')}
              value={parsed?.toFormattedString() ?? callerPhoneNumber}
              allowCopyToClipboard
              linkUrl={parsed?.getUrlForCall() ?? `tel:${callerPhoneNumber}`}
              valueToCopy={callerPhoneNumber}
            />
          );
        })}
      </>
    );
  }

  return (
    <DataPanelInlineItem
      title={t('Incident_InfoPanel_Phone')}
      editable={editable}
      showEmptyPlaceholder
      onEditClick={() => openPhoneNumberDialog(incidentId)}
    />
  );
}
